export default "__VITE_ASSET__BRBMsa4___"